import {Determinant} from "./determinant";
import { NumericOperatorType } from "./numeric-operator";

export class NumericDeterminant extends Determinant {

  public numericValue: number;
  public operator: NumericOperatorType;

}
